<template>
  <el-dialog :title="uuid ? '编辑小程序' : '添加小程序'" :visible.sync="dialogFormVisible" width="600px">
    <el-form
      :rules="rules"
      ref="dataForm"
      :model="temp"
      label-position="left"
      label-width="100px"
      style="margin: 0 30px;"
    >
      <template>
        <el-form-item label="小程序名称" prop="title">
          <el-input type="text" v-model="temp.title" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="小程序类型" prop="mini_type">
          <el-radio-group v-model="temp.mini_type" :disabled="!!uuid">
            <el-radio :label="1">微信小程序</el-radio>
            <el-radio :label="2">内嵌小程序</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="AppID" prop="appid">
          <el-input type="text" v-model="temp.appid" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="原始ID" v-if="temp.mini_type == 1" required>
          <el-input type="text" v-model="temp.original_id" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="上传图片" required>
          <img-upload class-name="miniprogram-upload" tip-size="100px 100px" v-model="temp.image" skin="small" />
        </el-form-item>
        <el-form-item label="选择标签" prop="tag">
          <el-radio-group v-model="temp.tag">
            <el-radio :label="1">无</el-radio>
            <el-radio :label="2">hot</el-radio>
            <el-radio :label="3">new</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="小程序介绍" prop="intro">
          <el-input type="textarea" :rows="5" v-model="temp.intro" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input type="number" v-model.number="temp.order" min="0"></el-input>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail, add, edit } from "@/api/exercise";
import ImgUpload from "@/components/ImgUpload";
import { validatOrder } from "@/utils/validate";

export default {
  name: "ExerciseEdit",
  components: { ImgUpload },
  data() {
    return {
      dialogFormVisible: false,
      uuid: "",
      temp: {
        title: "",
        appid: '',
        original_id: '',
        image: '',
        tag: 1,
        intro: '',
        order: 0,
        is_enable: 1,
        mini_type: 1
      },
      rules: {
        title: [{ required: true, message: "必填项不能为空" }],
        appid: [{ required: true, message: "必填项不能为空" }],
        intro: [{ required: true, message: "必填项不能为空" }],
        order: [
          { required: true, message: "必填项不能为空", trigger: "change" },
          { validator: validatOrder, trigger: "change" }
        ]
      }
    };
  },
  methods: {
    // 添加
    handleCreate() {
      this.uuid = "";
      this.temp = {
        title: "",
        appid: '',
        original_id: '',
        image: '',
        tag: 1,
        intro: '',
        order: 0,
        is_enable: 1,
        mini_type: 1
      };
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    // 编辑
    handleEdit(uuid) {
      this.uuid = uuid;
      getDetail(uuid).then(res => {
        Object.assign(this.temp, res.data)
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.$refs["dataForm"].clearValidate();
        });
      })
    },
    // 保存
    saveData() {
      let {image, mini_type, original_id} = this.temp
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          if (!image) {
            return this.$message.error("请上传图片");
          }
          if (mini_type == 1 && !original_id) {
            return this.$message.error("不能为空");
          }
          let d = JSON.parse(JSON.stringify(this.temp));
          const p = this.uuid ? edit(this.uuid, d) : add(d);
          p.then(() => {
            this.$parent.fetchData();
            this.dialogFormVisible = false;
            this.$parent.$notify({
              title: "成功",
              message: this.uuid ? "修改成功" : "添加成功",
              type: "success"
            });
          });
        }
      });
    }
  }
};
</script>

<style>
.miniprogram-upload .el-upload-dragger {
  width: 100px;
  height: 100px;
}
.miniprogram-upload .uploader-icon {
  margin-top: 18px;
}
</style>
